<div class="modal">
  <div class="container model-container {{context.customClass}}">
    <div class="modal-header">
      <h2 class="modal-heading">{{context.title}}</h2>
      <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
        alt="Close Icon">
    </div>
    <div class="modal-body">
      <div class="modal-content">
        <div class="form-section payment-form">
          <form [formGroup]="ccForm">
            <p class="form-title text-bold">Credit Card Details</p>

            <label>Expiration date</label>
            <input class="expiry-input" type="text" formControlName="expiry" maxlength="5" placeholder="MM/YY"
              (input)="onExpiryInput($event)">

            <p class="validation-message"
              *ngIf="ccForm.controls.expiry.touched && ccForm.controls.expiry.hasError('required')">
              Expiry date is required
            </p>

            <p class="validation-message"
              *ngIf="ccForm.controls.expiry.touched && ccForm.controls.expiry.hasError('pattern')">
              Invalid format (MM/YY)
            </p>

            <p class="validation-message"
              *ngIf="ccForm.controls.expiry.touched && ccForm.controls.expiry.hasError('expired')">
              Card is expired
            </p>
          </form>
        </div>
        <div class="form-section address-form">
          <h5 class="form-title">Billing address</h5>
          <p class="form-subtitle caption"><b>Hint:</b> Enter Full Name as it’s written on the card.</p>

          <app-address-lookup #addressLookup [populateForm]="!!billingAddress?.address1"
            [displayedAddress]="billingAddress || {}" (addressChange)="addressLookUpChanged($event)"
            [resetForm]="resetAddressForm">
          </app-address-lookup>
        </div>
        <div class="modal-actions">
          <button class="button primary" data-cy="updatePaymentBtn" (click)="savePaymentInfo()">
            Save
          </button>
          <button class="button tertiary" (click)="closeDialog()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
